import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    signal,
    viewChild,
} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TooltipCustomComponent } from '../tooltip-custom/tooltip-custom.component';

@Component({
    selector: 'apcam-menu-navbar-divider',
    templateUrl: './menu-navbar-divider.component.html',
    styleUrls: ['./menu-navbar-divider.component.scss'],
    imports: [MatDividerModule, TooltipCustomComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuNavbarDividerComponent {
    readonly tooltip = input<string | null>(null);

    readonly ariaLabel = input<string | null>(null);

    private readonly label = viewChild<ElementRef<HTMLElement>>('label');

    protected readonly tooltipEnabled = signal(false);

    protected updateTooltipState(): void {
        const label = this.label()?.nativeElement;

        if (!label) {
            this.tooltipEnabled.set(false);
            return;
        }

        this.tooltipEnabled.set(label.scrollWidth > label.clientWidth);
    }
}
